export const headerData = [
  {
    text: "User ID",
  },
  {
    text: "CNIC",
  },
  {
    text: "Created Date",
  },
  {
    text: "Updated Date",
  },
  {
    text: "Status",
  },
  {
    text: "",
  },
];

export const footerData = {
  title: "No record found",
  subTtitle: "No such record exists.",
  imgSrc: "../../../assets/images/no-search-icon.svg",
  alt: "no search found",
};

export const bodyDataAndKeyTypes = [
  {
    key: "userId",
    type: "",
  },
  {
    key: "nationalId",
    type: "",
  },
  {
    key: "createdAt",
    type: "",
  },
  {
    key: "updatedAt",
    type: "",
  },
  {
    key: "status",
    type: "",
  },
  {
    key: "",
    type: "",
  },
];
